import clsx from "clsx";
import React, { useState } from "react";

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import * as Sentry from "@sentry/browser";

import { makeRequest, isValidUrl } from "./util";
import Navigation from "./Navigation.js";

import AutocompleteField from "./AutocompleteField";

const useStyles = makeStyles(() => ({
  navigation: {
    paddingTop: 24,
  },
  card: {
    width: "50%",
    minWidth: 800,
  },
  content: {
    padding: 24,
  },
}));

function VisualEditor() {
  const classes = useStyles();

  const [url, setURL] = useState("https://");
  const [errorMsg, setErrorMsg] = useState(null);

  function openVisualEditor() {
    if (!isValidUrl(url)) {
      setErrorMsg("This URL is invalid");
      return;
    }

    makeRequest("create_visual_editor_token", {})
      .then((response) => {
        const params = {
          action: "fpeditor",
          temporaryToken: response.data.token,
          projectToken: response.data.env_id,
        };

        const fullURL =
          url + "#fpState=" + encodeURIComponent(JSON.stringify(params));
        window.freshpaint.track("Launched Editor", {
          baseURL: url,
          fullUrl: fullURL,
        });
        window.location.assign(fullURL);
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.log("Got an error.", error);
      });
  }

  return (
    <>
      <Typography component="h2" gutterBottom variant="overline">
        Visual Editor
      </Typography>
      <Typography component="h1" gutterBottom variant="h3">
        Point-and-click labeling of new events.
      </Typography>
      <Card className={classes.card}>
        <CardHeader title="Launch Visual Editor for Web" />
        <Divider />
        <CardContent className={classes.cardContent}>
          <Typography>
            Enter a URL to start labeling new events with the Visual Editor. For
            advanced users that need additional flexibility labeling an event,
            use the <a href="/events/schema">Event Schema view.</a>
          </Typography>

          <br />
          <br />

          <Grid container spacing={2}>
            <Grid item xs={8}>
              <AutocompleteField
                propName="$current_url"
                fullWidth
                autoComplete="off"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="url-field"
                onChange={(val) => {
                  setErrorMsg(null);
                  setURL(val);
                }}
                value={url}
                placeholder="https://"
              />
              {errorMsg && (
                <div className="text-sm text-red-800">{errorMsg}</div>
              )}
            </Grid>

            <Grid item xs={3}>
              <Button
                style={{ marginTop: 8 }}
                color="primary"
                onClick={openVisualEditor}
                variant="contained"
              >
                Launch Editor
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

function VisualEditorWithNavigation() {
  const classes = useStyles();

  return (
    <Navigation className={clsx(classes.navigation)}>
      <VisualEditor />
    </Navigation>
  );
}

export default VisualEditorWithNavigation;
